import {
  Scale,
  Briefcase,
  Gavel,
  AlertTriangle,
  FileSearch,
  ShieldAlert,
  HardHat,
} from "lucide-react";

const SERVICES = [
  {
    icon: Scale,
    title: "Perícia Judicial Odontológica",
    description:
      "Análise técnica de prontuários, exames, radiografias e condições clínicas para esclarecer fatos em processos judiciais. Elaboração de laudos imparciais e resposta a quesitos das partes e do Juízo.",
  },
  {
    icon: Briefcase,
    title: "Assistência Técnica Judicial",
    description:
      "Representação dos interesses técnicos de advogados, clínicas, empresas e pacientes — análise de processos, formulação de quesitos, acompanhamento de perícias e contestação técnica de laudos.",
  },
  {
    icon: Gavel,
    title: "Odontologia Legal",
    description:
      "Aplicação dos conhecimentos odontológicos em questões jurídicas: investigações, identificação humana, produção de provas técnicas e quantificação de prejuízos estéticos e funcionais.",
  },
  {
    icon: AlertTriangle,
    title: "Perícia em Erro Odontológico",
    description:
      "Avaliação de planejamento, conduta profissional, documentação, consentimento informado e nexo causal entre conduta e dano alegado — sempre com base em evidências científicas.",
  },
  {
    icon: ShieldAlert,
    title: "Avaliação de Danos Odontológicos",
    description:
      "Análise técnica de danos por acidentes de trânsito, trabalho, agressões, quedas, traumas faciais e perda dentária — aspectos estéticos, funcionais, psicológicos e econômicos.",
  },
  {
    icon: FileSearch,
    title: "Análise de Prontuários Odontológicos",
    description:
      "Identificação de ausência de registros obrigatórios, falhas documentais, inconsistências clínicas e falta de consentimento informado — essencial para defesa profissional ou comprovação de direitos.",
  },
  {
    icon: HardHat,
    title: "Odontologia do Trabalho",
    description:
      "Avaliação da saúde bucal ocupacional, programas preventivos, pareceres técnicos e análise de impactos ocupacionais relacionados à saúde bucal para empresas e trabalhadores.",
  },
];

export const Services = () => {
  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-[#080808] overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay pointer-events-none" />

      <div className="relative w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#D4AF37]" />
            <span className="text-xs tracking-[0.32em] uppercase text-[#D4AF37]">
              Serviços Periciais
            </span>
          </div>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight tracking-tight">
            Expertise técnica em{" "}
            <span className="italic text-[#D4AF37]">odontologia forense</span>.
          </h2>
          <p className="mt-6 text-white/65 max-w-2xl leading-relaxed">
            Atuação imparcial e fundamentada em evidências científicas, com o
            objetivo de apoiar a Justiça na busca pela verdade técnica.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#D4AF37]/10">
          {SERVICES.map((service, i) => {
            const Icon = service.icon;
            return (
              <article
                key={i}
                data-testid={`service-card-${i}`}
                className="group relative bg-[#0a0a0a] p-8 lg:p-10 hover:bg-[#111111] transition-all duration-500 min-h-[280px]"
              >
                <Icon
                  size={36}
                  strokeWidth={1.3}
                  className="text-[#D4AF37] mb-6 group-hover:scale-110 transition-transform duration-500"
                />
                <h3 className="font-serif-display text-xl lg:text-2xl text-white mb-3 leading-snug">
                  {service.title}
                </h3>
                <p className="text-sm text-white/60 leading-relaxed">
                  {service.description}
                </p>
                <div className="absolute bottom-0 left-0 h-px w-0 bg-[#D4AF37] group-hover:w-full transition-all duration-500" />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
